// ABOUTME: Contact page for submitting bug reports and feature requests.
// ABOUTME: POSTs form data to Web3Forms; no backend involvement.
import { useState } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import Button from '@mui/material/Button'
import Alert from '@mui/material/Alert'

const WEB3FORMS_KEY = import.meta.env.VITE_WEB3FORMS_KEY as string

type FormState = 'idle' | 'submitting' | 'success' | 'error'

export function ContactPage() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [type, setType] = useState('bug')
  const [message, setMessage] = useState('')
  const [formState, setFormState] = useState<FormState>('idle')

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setFormState('submitting')
    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ access_key: WEB3FORMS_KEY, name, email, type, message }),
      })
      const data = await res.json()
      setFormState(data.success ? 'success' : 'error')
    } catch {
      setFormState('error')
    }
  }

  return (
    <Container maxWidth="sm">
      <Box py={6}>
        <Typography variant="h3" component="h1" gutterBottom>
          Contact Us
        </Typography>
        <Typography paragraph color="text.secondary">
          Found a bug or have a feature request? Let us know and we'll get back to you.
        </Typography>

        {formState === 'success' ? (
          <Alert severity="success">
            Thanks for reaching out! We'll get back to you soon.
          </Alert>
        ) : (
          <Box component="form" onSubmit={handleSubmit} noValidate>
            {formState === 'error' && (
              <Box mb={2}>
                <Alert severity="error">
                  Something went wrong. Please try again.
                </Alert>
              </Box>
            )}
            <TextField
              label="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              required
              margin="normal"
            />
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              required
              margin="normal"
            />
            <TextField
              label="Type"
              select
              value={type}
              onChange={(e) => setType(e.target.value)}
              fullWidth
              required
              margin="normal"
            >
              <MenuItem value="bug">Bug Report</MenuItem>
              <MenuItem value="request">Feature Request</MenuItem>
            </TextField>
            <TextField
              label="Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              fullWidth
              required
              multiline
              rows={5}
              margin="normal"
            />
            <Box mt={2}>
              <Button
                type="submit"
                variant="contained"
                disabled={formState === 'submitting'}
              >
                {formState === 'submitting' ? 'Sending…' : 'Send'}
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Container>
  )
}
